import styled from 'styled-components';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing } from 'stylesheetB2b';

const LAST_SONG_CONTAINER_LEFT_RIGHT_PADDING = getSpacing(3);

export const RemainingTimeContainer = styled.div<{ colors: ColormapInterface }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  padding-left: ${LAST_SONG_CONTAINER_LEFT_RIGHT_PADDING};
  border-top: solid 1px;
  border-color: ${({ colors }) => colors.lastSongBorder};
  background: linear-gradient(
    to bottom,
    ${({ colors }) => colors.remainingTimeBackground} 70%,
    rgb(231 46 92 / 50%) 100%
  );
  gap: 6px;
`;

export const RemainingTimeHeader = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  font-size: 13px;
`;

export const ButtonModalExtensionStyle = {
  backgroundColor: '#ffffff',
  color: '#000000',
  borderRadius: '20px',

  '&:hover': {
    backgroundColor: '#ffffff',
  },

  '&.Mui-disabled': {
    backgroundColor: '#C0C0C0 !important',
    color: 'white !important',
  },
};

export const ModalExtensionContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  height: 300,
  bgcolor: '#000000',
  borderRadius: '2px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '24px',
};

export const CloseButtonStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  cursor: 'pointer',
};
